module.exports = __webpack_public_path__ + "static/media/refpay.e818125e.svg";